<template>
  <nav class="flex flex-wrap items-center justify-center gap-2 py-1">
    <button
      :disabled="!hasPreviousPages || linksDisabled"
      type="button"
      class="flex size-9 items-center justify-center rounded-full border border-zinc-200/70 text-sm text-zinc-500 transition hover:bg-zinc-100 focus:outline-none disabled:opacity-40 dark:border-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800"
      rel="first"
      @click.prevent="selectPage(1)"
      dusk="first"
    >
      &laquo;
    </button>

    <button
      :disabled="!hasPreviousPages || linksDisabled"
      type="button"
      class="flex size-9 items-center justify-center rounded-full border border-zinc-200/70 text-sm text-zinc-500 transition hover:bg-zinc-100 focus:outline-none disabled:opacity-40 dark:border-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800"
      rel="prev"
      @click.prevent="selectPreviousPage()"
      dusk="previous"
    >
      &lsaquo;
    </button>

    <button
      v-for="n in printPages"
      :key="n"
      :disabled="linksDisabled"
      type="button"
      class="flex size-9 items-center justify-center rounded-full text-sm font-medium transition focus:outline-none"
      :class="
        page === n
          ? 'bg-brand-500 text-white'
          : 'border border-zinc-200/70 text-zinc-600 hover:bg-zinc-100 dark:border-zinc-700 dark:text-zinc-300 dark:hover:bg-zinc-800'
      "
      @click.prevent="selectPage(n)"
      :dusk="`page:${n}`"
    >
      {{ n }}
    </button>

    <button
      :disabled="!hasMorePages || linksDisabled"
      type="button"
      class="flex size-9 items-center justify-center rounded-full border border-zinc-200/70 text-sm text-zinc-500 transition hover:bg-zinc-100 focus:outline-none disabled:opacity-40 dark:border-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800"
      rel="next"
      @click.prevent="selectNextPage()"
      dusk="next"
    >
      &rsaquo;
    </button>

    <button
      :disabled="!hasMorePages || linksDisabled"
      type="button"
      class="flex size-9 items-center justify-center rounded-full border border-zinc-200/70 text-sm text-zinc-500 transition hover:bg-zinc-100 focus:outline-none disabled:opacity-40 dark:border-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800"
      rel="last"
      @click.prevent="selectPage(pages)"
      dusk="last"
    >
      &raquo;
    </button>

    <slot />
  </nav>
</template>

<script>
export default {
  emits: ['page'],

  props: {
    page: {
      type: Number,
      required: true,
    },
    pages: {
      type: Number,
      default: 0,
    },
    next: {
      type: Boolean,
      default: false,
    },
    previous: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({ linksDisabled: false }),

  mounted() {
    Nova.$on('resources-loaded', this.listenToResourcesLoaded)
  },

  beforeUnmount() {
    Nova.$off('resources-loaded', this.listenToResourcesLoaded)
  },

  methods: {
    selectPage(page) {
      if (this.page != page) {
        this.linksDisabled = true
        this.$emit('page', page)
      }
    },

    selectPreviousPage() {
      this.selectPage(this.page - 1)
    },

    selectNextPage() {
      this.selectPage(this.page + 1)
    },

    listenToResourcesLoaded() {
      this.linksDisabled = false
    },
  },

  computed: {
    hasPreviousPages() {
      return this.page > 1
    },

    hasMorePages() {
      return this.page < this.pages
    },

    printPages() {
      const middlePage = Math.min(Math.max(3, this.page), this.pages - 2)
      const fromPage = Math.max(middlePage - 2, 1)
      const toPage = Math.min(middlePage + 2, this.pages)

      const pages = []

      for (let n = fromPage; n <= toPage; ++n) {
        if (n > 0) {
          pages.push(n)
        }
      }

      return pages
    },
  },
}
</script>
